<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
    <!--  <modal-link modal-id="How to Use" :content-list="pageContent" :image-size="'large'"></modal-link> -->
      {{ chart.title }}
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" display-type-label="Profile Types" showUseTTMAsStartDate="true" :show-match-type="true" :use-chart-type-card="true" :show-display-type="true" :is-comparative="true" time-period-label="Period" :content-list="pageContent" @reset-client-chart="resetClientChart" @match-type-change="setMatchType"
      @reset-sub-chart-criteria="resetMatchProfileAnalysisCriteria">
      </chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  v-bind:criteria-results-list="criteriaResultsList"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"
                ></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <MatchByNeed ref="byNeed" v-show="isMatchByNeed && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData" :top-attribute-recommendations-data="topAttributeRecommendations" :top-attribute-recommendations-legend-name="topAttributeRecommendationsLegendName"></MatchByNeed>
              <MatchByValue ref="byMoat" v-show="isMatchByValue && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData" ></MatchByValue>
              <MatchByWinners v-show="isMatchByWinners && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData"></MatchByWinners>
              <MatchByMoat v-show="isMatchByMoat && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData" :top-attribute-recommendations-data="topAttributeRecommendations" :top-attribute-recommendations-legend-name="topAttributeRecommendationsLegendName" ></MatchByMoat>
              <ByWordCloud v-show="isMatchByWordCloud && !generatingChart" :chart-data="chartData" :include-word-cloud="false" @set-recommendations-data="handleRecommendationsData"></ByWordCloud>
              <match-profile-analysis v-show="showMatchProfileAnalysis && !generatingChart && getDisplayView()" 
                ref="matchProfileAnalysis"
                :client-chart="this.clientChart" 
                :client-object="clientObject"
                :criteria-results-company-list="criteriaResultsCompanyList"
                :entry-survey-code="this.surveyCode" :client-settings="clientSettings"
                :recommendations-data="recommendationsData"
                :comparative-saved-cards="comparativeSavedCards"
                :match-type="currentMatchType"
                :show-insight-type="currentMatchType != 'time-period'"
                @set-default-title="setInstantReportDefaultTitle"
                @top-attribute-recommendations="handleTopAttributeRecommendations"
                @save-match-profile-analysis-criteria="handleSaveMatchProfileAnalysisCriteria"></match-profile-analysis>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
    </vue-modal>
    <vue-modal ref="print-chart" name="print-chart" :width="350" :height="200">
      <chart-criteria-results
        ref="chartCriteriaResults"
        v-bind:criteria-results-list="criteriaResultsList"
        v-bind:criteria-results-company-list="criteriaResultsCompanyList"
      ></chart-criteria-results>
    </vue-modal>
    <roadmap-initiatives-modal ref="roadMapInitiativesForProfileTable" :modal-name="'road-map-initiatives-profile'" />      
    <explore-navigation-modal  ref="exploreNavigationModal" :modal-name="'explore-navigation-modal'" :modal-id="'explore-navigation-modal'"/>  
    <print-instant-report-modal ref="printInstantReportModal" :client-report-id="clientReportId" :existing-client-report="existingClientReport" 
        :default-title="clientChart && clientChart.clientChartId > 0 && clientChart.name ? clientChart.name : instantReportDefaultTitle" :default-sub-title="instantReportDefaultSubTitle" :before-generate-report="copyContentForReport" />
  </div>
</template>
<script>
import RoadmapInitiativesModal from "../../modals/RoadmapInitiativesModal.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";

import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import MatchByNeed from "./type/MatchByNeed.vue";
import MatchByValue from "./type/MatchByValue.vue";
import MatchByMoat from "./type/MatchByMoat.vue";
import MatchByWinners from "./type/MatchByWinners.vue";
import ByWordCloud  from "./type/ByWordCloud.vue";
import MatchProfileAnalysis from "../../components/chart/MatchProfileAnalysis.vue";
import PrintInstantReportModal from "../../modals/PrintInstantReportModal.vue";

import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import ContentService from "../../services/content.service";

export default {
  name: "ProfileMatch",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    MatchByNeed,
    MatchByValue,
    MatchByWinners,
    MatchByMoat,
    ByWordCloud,
    MatchProfileAnalysis,
    ChartDisplaySkeleton,
    ExploreNavigationModal,
    RoadmapInitiativesModal,
    PrintInstantReportModal
  },
  data() {
    return {
      title: "Match",
      pageNumber: 8,
      clientReportId: 0,
      isMatchByNeed: true,
      isMatchByValue: false,
      isMatchByMoat: false,
      isMatchByWinners: false,
      isMatchByWordCloud: false,
      currentMatchType: "",
      matchProfileAnalysisCriteria: "",
      chartData: [],
      topAttributeRecommendations: [],
      topAttributeRecommendationsLegendName: "Insights",
      comparativeSavedCards: [],
      instantReportDefaultTitle: "",
      instantReportDefaultSubTitle: ""
    };
  },
  methods: {
    handleRecommendationsData(data) {
      //console.log('final data = ', data);
      this.recommendationsData = data;
      this.setComparativeSavedCardsFromCriteria();
    },
    displayChartCallback(response) {
      try {
        if (this.$refs.matchProfileAnalysis != null) {
          this.$refs.matchProfileAnalysis.$data.pageContent = this.$refs.chartCriteria.$data.pageContent;
        }

        this.$root.processServerResponse();
        this.generatingChart = false;

        this.chartData = response.data;
        this.isMatchByNeed = this.$refs.chartCriteria.$data.displayType == "need";
        this.isMatchByValue = this.$refs.chartCriteria.$data.displayType == "value";
        this.isMatchByMoat = this.$refs.chartCriteria.$data.displayType == "moat";
        this.isMatchByWinners = this.$refs.chartCriteria.$data.displayType == "winners";
        this.isMatchByWordCloud  = this.$refs.chartCriteria.$data.displayType == "nps";
        this.currentMatchType = this.$refs.chartCriteria.$data.matchType;
        this.instantReportDefaultSubTitle = "";
        this.resetMatchProfileAnalysisCriteria();
      } catch (err) {
        ErrorService.processException("ProfileMatch.displayChartCallback", err, "chart", this);
      }
    },
    setMatchType(matchType) {
      this.currentMatchType = matchType;
    },
    setComparativeSavedCardsFromCriteria() {
      if(this.currentMatchType == "saved-card") {
        this.comparativeSavedCards = this.$refs.chartCriteria?.$data?.comparativeSavedCards || [];
      }
      if(this.currentMatchType == "time-period") {
        this.comparativeSavedCards = this.$refs.chartCriteria?.$data?.comparativePeriods || [];
      }
      this.recommendationsData.cardList = this.comparativeSavedCards;
    },
    handleSaveMatchProfileAnalysisCriteria(params) {
      this.matchProfileAnalysisCriteria = params.toString();
      const existingParams = new URLSearchParams(this.clientChart.criteria);
      const newParams = new URLSearchParams(this.matchProfileAnalysisCriteria);
      for (const [key, value] of newParams.entries()) {
          existingParams.set(key, value);
      }
      this.clientChart.criteria = existingParams.toString();
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    displayInitiativesForProfileTable(element) {
      let needName = element.name;
      let moatName = element.moatName;
      let moatDescription = element.moatDescription;
      if (moatDescription == null) {
        moatDescription = {
          description: "",
          attributes: "{}"
        };
      }
      let initiativeSuggestions = element.initiativeSuggestions;
      this.$refs.roadMapInitiativesForProfileTable.$data.title = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.moatName = moatName;
      this.$refs.roadMapInitiativesForProfileTable.$data.needName = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.initiatives = JSON.parse(JSON.stringify(initiativeSuggestions));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatDescription = JSON.parse(JSON.stringify(moatDescription));
      this.$refs.roadMapInitiativesForProfileTable.$data.displayInitiatives = false;
      this.$refs.roadMapInitiativesForProfileTable.$data.showCustomInitiative = false;
      this.$refs.roadMapInitiativesForProfileTable.$data.addOrSaveInitiative = "Add Initiative";
      this.$refs.roadMapInitiativesForProfileTable.$data.saveEnabled = false;
      this.$refs.roadMapInitiativesForProfileTable.loadData();
      this.$modal.show("road-map-initiatives-profile");
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    async copyContentForReport(clientReportId) {
      this.clientReportId = clientReportId;
      if (this.isMatchByNeed && this.$refs.byNeed != null) {
        await this.$refs.byNeed.saveInstantReportChartImage(clientReportId);
      }
      else if (this.isMatchByMoat && this.$refs.byMoat != null) {
        await this.$refs.byMoat.saveInstantReportChartImage(clientReportId);
      }

      // Save sentiments data if it exists
      if (this.$refs.matchProfileAnalysis != null) {
        return await this.$refs.matchProfileAnalysis.saveDataForInstantReport(clientReportId);
      }
      return "";
    },
    setInstantReportDefaultTitle: function(analysisType, savedCardNames) {
      this.instantReportDefaultTitle = "W Report";
      if (this.clientObject != null && typeof this.clientObject.name == "string") {
        if (typeof analysisType != "undefined" && analysisType != null) {
          if (analysisType == "conversion") {
            this.instantReportDefaultTitle += ' - Conversion';
             if (Array.isArray(savedCardNames) && savedCardNames.length > 1) {
               this.instantReportDefaultTitle += ' - ' + savedCardNames[0];
               this.instantReportDefaultTitle += ' - ' + savedCardNames[1];
             }
          } else if (analysisType == "variation") {
            this.instantReportDefaultTitle += ' - Variation';
            if (Array.isArray(savedCardNames) && savedCardNames.length > 1) {
              this.instantReportDefaultTitle += ' - ' + savedCardNames[0];
            }
          } 
        } 
        // copy cardNames to data for use in report sub title
        this.$refs.printInstantReportModal.savedCardNames = savedCardNames;
        this.$refs.printInstantReportModal.insightType = analysisType;
      }
      if (this.$refs.chartCriteria != null && typeof this.$refs.chartCriteria.getPeriodName == "function") {
        this.instantReportDefaultSubTitle = this.$refs.chartCriteria.getPeriodName(this.$refs.chartCriteria.$data.period);
      }
    },
    handleTopAttributeRecommendations(topAttributeRecommendations, insightType) {
      this.topAttributeRecommendations = JSON.parse(JSON.stringify(topAttributeRecommendations));
      this.topAttributeRecommendationsLegendName = insightType === "conversion" ? "Conversion Insights" : "Variation Insights";
    },
    resetMatchProfileAnalysisCriteria() {
      this.clientReportId = 0;
      this.topAttributeRecommendations = [];
      this.topAttributeRecommendationsLegendName = "Insights";
      if (this.$refs.matchProfileAnalysis && !this.$refs.matchProfileAnalysis.$data.isSavedCard) {
          this.$refs.matchProfileAnalysis.resetValues();
      }
    },
  },
  umnounted() {},
  computed: {
    showMatchProfileAnalysis() {
      return (this.currentMatchType == "saved-card" || this.currentMatchType == "time-period") && !this.isMatchByWordCloud; 
    }
  },
  props: {},
  mounted() {},
  created() {
    this.chart = ChartService.getChartAttributes("Match");
  },
  watch: {
    surveyCode: function(newVal, oldVal) {
      this.recommendationsData = {};
      this.topAttributeRecommendations = [];    
      this.topAttributeRecommendationsLegendName = "Insights";
    }
  }
};
</script>
